import Keycloak from 'keycloak-js';
import { decodeToken } from './utils'

const keycloak = new Keycloak({
    url: process.env.VUE_APP_KEYCLOAK_URL,
    realm: process.env.VUE_APP_KEYCLOAK_REALM,
    clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID
});

const session = {
    decodedToken: null
}

let initPromise = null

const initKeycloak = () => {
    if (initPromise) return initPromise

    initPromise = keycloak.init({
        checkLoginIframe: false
    }).then(authenticated => {
        if (authenticated) {
            session.decodedToken = decodeToken(keycloak.token)
        }
        return authenticated
    }).catch(err => {
        console.error('Failed to initialize Keycloak', err);
        return false
    });

    return initPromise;
};

const POST_LOGIN_REDIRECT_KEY = 'uqm-post-login-redirect'

const login = (options) => {
    sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, '/app')
    return keycloak.login(options ?? { redirectUri: window.location.origin + '/' });
}

const consumePendingRedirect = () => {
    const pending = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY)
    if (pending) sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY)
    return pending
}
const logout = (options) => keycloak.logout(options ?? { redirectUri: window.location.origin + '/' });

const getToken = () => keycloak.token;
const isAuthenticated = () => keycloak.authenticated;

const getUserEmail = () => session.decodedToken.email
const getUserFullName = () => session.decodedToken.name
const hasResourceRole = keycloak.hasResourceRole

export { initKeycloak, login, logout, getToken, isAuthenticated, hasResourceRole, getUserEmail, getUserFullName, consumePendingRedirect };